import { MediaManagerCategory } from '@wix/editorx-core-api';

const MEDIA_TYPE = {
  photos: 'IMAGE',
  secure_picture: 'IMAGE_PRO',
  backgrounds: 'BG_IMAGE',
  audio: 'MUSIC',
  documents: 'DOCUMENT',
  secure_music: 'MUSIC_PRO',
  swf: 'FLASH',
  video: 'VIDEO',
  shape: 'SHAPE',
  music: 'MUSIC',
  clipart: 'IMAGE',
  bg_video: 'BG_VIDEO',
  icon_document: 'ICON_DOCUMENT',
  bg_social: 'ICON_SOCIAL',
  bg_favicon: 'ICON_FAVICON',
} as const;

type MessageMediaType = keyof typeof MEDIA_TYPE;
type MediaTypeValue = (typeof MEDIA_TYPE)[MessageMediaType];

const MEDIA_TYPE_TO_PLATFORM_CATEGORY: Record<
  MediaTypeValue,
  MediaManagerCategory
> = {
  IMAGE: MediaManagerCategory.Image,
  IMAGE_PRO: MediaManagerCategory.Image,
  ICON_SOCIAL: MediaManagerCategory.Image,
  ICON_FAVICON: MediaManagerCategory.Image,

  BG_IMAGE: MediaManagerCategory.BgImage,

  SHAPE: MediaManagerCategory.Cursor,

  DOCUMENT: MediaManagerCategory.Document,
  ICON_DOCUMENT: MediaManagerCategory.Document,
  FLASH: MediaManagerCategory.Document,

  MUSIC: MediaManagerCategory.AllMedia,
  MUSIC_PRO: MediaManagerCategory.AllMedia,
  VIDEO: MediaManagerCategory.AllMedia,
  BG_VIDEO: MediaManagerCategory.AllMedia,
};

export const getCategory = (
  mediaType: MessageMediaType,
): MediaManagerCategory => {
  const internalCategory = MEDIA_TYPE[mediaType];
  if (!internalCategory) {
    throw new Error(
      `No category for media type ${mediaType}: openMediaDialogMessageTypeHandler getCategory mediaType is not supported`,
    );
  }

  const platformCategory = MEDIA_TYPE_TO_PLATFORM_CATEGORY[internalCategory];
  if (!platformCategory) {
    throw new Error(
      `No platform category mapping for internal category ${internalCategory}: openMediaDialogMessageTypeHandler getCategory category is not supported`,
    );
  }

  return platformCategory as MediaManagerCategory;
};

export const convertMediaManagerResult = function (
  // TODO - refactor this type in REP:
  mediaData: Record<string, any>, // MediaManagerBaseItem,
) {
  const mediaItem: Record<string, any> = {};

  mediaItem.fileName = mediaData.title || '';

  if (mediaData.mediaType === 'secure_music') {
    const audioFilesData = mediaData.fileOutput?.audio;

    const shortPreviewFileData = audioFilesData?.find(
      // TODO - remove explicit type after refactoring MediaManagerBaseItem type in REP
      ({ tag }: { tag: string }) => tag === 'preview-short',
    );
    mediaItem.shortPreviewFileName = shortPreviewFileData?.url || '';
    mediaItem.previewFileName = mediaData.previewFileName || '';
    mediaItem.fileUrl = mediaData.fileUrl || '';
  } else {
    mediaItem.relativeUri = mediaData.fileName || '';
    mediaItem.width = Number(mediaData.width) || 0;
    mediaItem.height = Number(mediaData.height) || 0;
  }

  return mediaItem;
};

export const convertMediaManagerResultForSuperApp = function (
  mediaData: Record<string, any>,
) {
  return {
    ...mediaData,
    relativeUri: mediaData.uri || '',
  };
};
